import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, Users, FileText, Tag, Mail, ArrowLeft } from 'lucide-react';

const AdminNavigation = () => {
  const location = useLocation();
  
  const menuItems = [
    { path: '/admin-prompts', label: '프롬프트 관리', icon: FileText },
    { path: '/admin-users', label: '사용자 관리', icon: Users },
    { path: '/admin-promo-codes', label: '프로모션 코드 관리', icon: Tag },
    { path: '/admin-promo-requests', label: '프로모션 요청 관리', icon: Mail },
  ];

  return (
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-3">
              <Shield className="h-6 w-6 text-blue-600" />
              <span className="font-semibold text-gray-900">관리자 페이지</span>
            </div>
            
            <nav className="flex space-x-6">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </nav>
          </div>
          
          <Link
            to="/dashboard"
            className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>대시보드로 돌아가기</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminNavigation;